export const BILLS_TRANSLATIONS = {
  all: 'All bills included',
  some: 'Some bills included',
  none: 'No bills included'
};

export const RENT_BY_TRANSLATIONS = {
  property: 'Entire place',
  unit: 'Private bedroom',
  subunit: 'Shared bedroom'
};

export const BATHROOM_TRANSLATIONS = {
  private_bathroom: 'Private bathroom',
  common_bathroom: 'Shared bathroom'
};

export const RULES_TRANSLATIONS = {
  'smoking-allowed': 'Smokers',
  'pets-allowed': 'Pets',
  'couples-allowed': 'Couples',
  'overnight-guests-allowed': 'Overnight guests'
};

export const BED_TYPE_TRANSLATIONS = {
  'single-bed': 'Single bed',
  'double-bed': 'Double bed',
  'twin-bed': 'Twin bed'
};

export const BEDROOM_TYPE_TRANSLATIONS = {
  'single-bed': 'Single bedroom',
  'double-bed': 'Double bedroom',
  'twin-bed': 'Twin bedroom'
};

export const UNIT_TYPE_TRANSLATIONS = {
  apartment: 'Apartment',
  studio: 'Studio',
  bathroom: 'Bathroom',
  bedroom: 'Bedroom',
  ensuite: 'Private bathroom',
  kitchen: 'Kitchen',
  'living-room': 'Living room',
  'dining-room': 'Dining room',
  wc: 'WC',
  house: 'House',
  other: 'Other'
};

export const REFERENCE_WITH_GENDER_BY_OFFER_TYPE = {
  house: {
    pt: 'female',
    es: 'female',
    it: 'female'
  },
  apartment: {
    de: 'female',
    en: 'an',
    fr: 'an'
  },
  property: {
    en: 'an',
    fr: 'an'
  },
  unit: {
    fr: 'an',
    es: 'female',
    it: 'female'
  },
  subunit: {
    fr: 'an',
    es: 'female',
    it: 'female'
  },
  bedroom: {
    es: 'female',
    it: 'female'
  }
};

export const LANDLORD_RESIDENT_AGE_RANGE_TRANSLATIONS = {
  'up-to-25': '20-25',
  'up-to-30': '25-30',
  'up-to-40': '30-40',
  'more-than-40': '40+'
};

export const PLACES_INFORMATION_TRANSLATIONS = {
  bar: 'Bar',
  bus_station: 'Bus station',
  grocery: 'Groceries',
  hospital: 'Hospital',
  metro_station: 'Metro station',
  parking: 'Parking',
  pharmacy: 'Pharmacy',
  post_office: 'Post office',
  restaurant: 'Restaurant'
};

export const LANDLORD_OCCUPATION_TRANSLATIONS = {
  'undergraduate-student': 'Undergraduate student',
  'professional-worker': 'Worker',
  'postgraduate-student': 'Postgraduate student'
};
